export default {
  component: () => import('./page.vue'),
  path: '/promo',
  name: 'promo',
};
